import { configureStore } from "@reduxjs/toolkit";
import storage from 'redux-persist/lib/storage'
import {combineReducers} from "redux"; 
import { persistReducer } from 'redux-persist';
import thunk from 'redux-thunk';
import appState from '../application/reducer/app_reducer.js';
import authState from '../application/reducer/auth_reducer.js';

/// <summary>
/// Author: -
/// </summary>
const reducers = combineReducers({
    appState,
    authState
});

/// <summary>
/// Author: -
/// </summary>
const persistConfig = {
    key: 'root',
    storage
};

/// <summary>
/// Author: -
/// </summary>
const persistedReducer = persistReducer(persistConfig, reducers);

/// <summary>
/// Author: -
/// </summary>
const store = configureStore({
    reducer: persistedReducer,
    middleware: [thunk]
});

export default store;